let infiniteSlides = [];
let iSlide = {
	width: 0,
	count: 0,
	max: 0,
	x: 0
}
let infiniteTimer;
let infiniteSlide = {
	beforeW: 0,
	beforeArry: [],
	init: function(){
		infiniteSlide.reset();
		$(".list_projects li.project").each(function(i){
			let $this = $(this);
			let len = $this.find(".img_project li").length;
			for(var j = 0; j < len; j++){
				let clone = $this.find(".img_project li").eq(j).clone();
				$this.find(".img_project ul").append(clone);
			}
			$this.find(".img_project ul").css({
				"transform": `translate3d(0%,0,0)`
			});
		});
		infiniteSlide.resize();
		infiniteSlide.start();
	},
	resize: function(){
		//console.log("infinite resize");
		
		infiniteSlides = [];
		$(".list_projects li.project").each(function(i){
			let $this = $(this);
			let _is = object(iSlide);
			_is.max = $(".img_project li", this).length/2;
			if(infiniteSlide.beforeArry.length > 0){
				_is.x 	= infiniteSlide.beforeArry[i].x;
			}else{
				_is.x 	= 0;
			}
			
			for(var j = 0; j < _is.max; j++){
				let img = $this.find(".img_project li").eq(j);
				_is.width += img.width() + parseInt( img.css("margin-left").replace("px", "") );
			}
			
			infiniteSlides.push(_is);
		});
		infiniteSlide.beforeArry = infiniteSlides;
	},
	start: function(){
		infiniteSlide.update();
	},
	update: function(){
		for(var i = 0; i < infiniteSlides.length; i++){
			let s = infiniteSlides[i];
			
			s.x -= 1;
			if(s.x < -s.width){
				s.x = 0;
			}
			$(".list_projects li.project").eq(i).find(".img_project ul").css({
				"transform": `translate3d(${s.x}px, 0, 0)`
			});
		}
		infiniteTimer = requestAnimationFrame(infiniteSlide.update);	
	},
	reset: function(){
		infiniteSlides = [];
		cancelAnimationFrame(infiniteTimer);
	}
}